import React from 'react';
import { Chip} from '@mui/material';

const PlanBadge: React.FC = () => {
  return (
    <Chip
      label="Basic"
      size="small"
      variant="outlined"
      sx={{
        fontWeight: 500,
        fontSize: '0.7rem',
        height: 24,
        borderColor: 'divider',
      }}
    />
  );
};

export default PlanBadge;
